import { NgModule } from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';
import { RouterModule } from '@angular/router';
import { MaterialModule} from '../material';
import { MatTableModule} from '@angular/material/table';
import { MatIconModule } from '@angular/material/icon';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { VoucherDialogComponent } from './voucher/voucher.component';
import { BrowserModule } from '@angular/platform-browser';
// import { BackgroundComponent } from '../helpers/background/background.component';
import { ToastrModule } from 'ngx-toastr';
import { ImageCropperComponent } from 'ngx-image-cropper';
import { ProfilePageComponent } from './profile/profile-page.component';
import { ManagerLoginComponent } from './manager-login/manager-login.component';
import { ManagerRegistrationComponent } from './manager-registration/manager-registration.component';
import { ManagerDashboardComponent } from './manager-dashboard.component';
import { ClientListComponent } from './client-list/client-list.component';
import { BackgroundModule } from '../helpers/background/background.module';
import { LoaderModule } from '../helpers/loader/loader.module';
import { ClientBusinessesComponent } from './client-businesses/client-businesses.component';
import { CreatePostComponent } from './create-post/create-post.component';
import { NgxEditorModule } from 'ngx-editor';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { VoucherComponent } from './voucher/voucher.component';


@NgModule({
  declarations: [
    // ProfilePageComponent,
    // ManagerLoginComponent,
    // ManagerRegistrationComponent,
    // ManagerDashboardComponent,
    // ClientListComponent, 
    ProfilePageComponent,
    ManagerLoginComponent,
    ManagerRegistrationComponent,
    ManagerRegistrationComponent,
    ManagerDashboardComponent,
    ClientListComponent,
    ClientBusinessesComponent,
    CreatePostComponent,
    VoucherComponent,
    VoucherDialogComponent

  ],
  imports: [
    CommonModule,BrowserAnimationsModule,BrowserModule,
    RouterModule,
    MaterialModule,
    MatIconModule,
    MatTableModule,
    FormsModule,
    BackgroundModule,
    // LoaderModule,
    ImageCropperComponent,
    MatSlideToggleModule,
    NgxEditorModule,
    ReactiveFormsModule.withConfig({ warnOnNgModelWithFormControl: 'never' }),
    ToastrModule.forRoot({
      positionClass: 'toast-bottom-right', 
      preventDuplicates: true,
      timeOut: 1000,  
  extendedTimeOut: 500,  
  progressBar: true,  

    }),
  ],
  providers: [
    DatePipe
  ]
})
export class  ManagerDashboardModule { }